<header class="masthead" style="position: fixed;">
	<div class="navbar">
		<div class="left-header-subscribe">
				<button id="create-workspace" class="back-to-workspace" data-toggle="dropdown" class="DAM-icon" (click)="switchToWorkspace()">
					<a class="navbar-brand js-scroll-trigger" href="javascript:;"><svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
					    <title>Back</title>
					    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
					        <g id="DAM-Pricing-Copy-2" transform="translate(-40.000000, -28.000000)">
					            <g id="Back" transform="translate(40.000000, 28.000000)">
					                <rect id="Rectangle-8" x="0" y="0" width="24" height="24"></rect>
					                <g id="Group-7" stroke-linecap="round" stroke-linejoin="round" transform="translate(3.000000, 6.000000)" stroke="#000000" stroke-width="1.5">
					                    <line x1="0" y1="6" x2="17.1428571" y2="6" id="Stroke-1"></line>
					                    <polyline id="Path-2" points="5.4 0 0 5.9256575 5.27460736 12"></polyline>
					                </g>
					            </g>
					        </g>
					    </g>
					</svg>
				</a>
					<span class="drop-down-option-workspace">
						Back to workspace
					</span>
				</button>
		</div>

		<div class="right-header">
			<div class="figma-icons-section">
        <div class="plugin-figma-icon">
          <button (click)="openFigma()" id="notification-pop-over" data-toggle="dropdown" class="anticon-bell-icon">
            <img src="assets/img/ic-figma.png">
          </button>
        </div>

        <div class="plugin-sketch-icon">
          <button (click)="openSketch()" id="notification-pop-over" data-toggle="dropdown" class="anticon-bell-icon">
            <img src="assets/img/ic-sketch.png">
          </button>
        </div>

        <div class="plugin-ai-icon">
          <button (click)="openIllustrator()" id="notification-pop-over" data-toggle="dropdown" class="anticon-bell-icon">
            <img src="assets/img/ai.png" style="width: 20px; height: 20px;">
          </button>
        </div>
      </div>

			<div class="menu-pop-over anticon-bell">
				<button id="notification-pop-over" data-toggle="dropdown" class="anticon-bell-icon" (click)="getNotifications()">
					<img src="assets/img/ic-noti.svg">
				</button>
				<!-- <span class="dot"></span> -->
				<div class="dropdown-menu notification-area" aria-labelledby="notification-pop-over">
						<div class="dropdown-container">
							<h5 class="notification-txt" style="margin-bottom:20px;"><b>Notifications</b></h5>
							<div class="notification-item">

								<!-- <div class="" *ngIf="showLoader">
									<img src="assets/img/loader.svg" style="margin-left: auto;margin-right: auto;display: block;width: 30%;" alt="">
								</div> -->

								<div *ngIf="notifications.length == 0" class="empty-notification-area">
									<img src="assets/img/no-noti.svg" alt="">
									<span>You have no notifications</span>
								</div>


								<ul *ngFor="let noti of notifications" style="padding: 0px;">
									<li style="border-bottom: 1px solid rgba(0,0,0,0.1);padding: 16px 0 16px 0;margin: 0 16px;">
										<div class="user-details-info">
										<div class="user-img">
											<span class="ant-avatar ant-avatar-circle ant-avatar-image ant-avatar-icon" style="width: 40px; height: 40px; line-height: 40px; font-size:18px; font-weight: 500;">
												<div class="email-initial-setup" [style.background-color]="getRandomColor()">
													{{getName(noti.firstName)}}{{getName(noti.lastName)}}
												</div>
											</span>
											</div>
											<div>
												<div class="user-info-name">
													<span>{{noti.message}} <b>{{noti.firstName}} {{noti.lastName}}</b></span>
												</div>
												<div class="" style="margin-top: 4px;">
													<span class="notification-date">{{noti.timestamp.toString().split(".")[0]}}</span>
												</div>
											</div>
										</div>
									</li>
								</ul>
							</div>
					</div>
				</div>
			</div>

			<div class="menu-pop-over user-name" *ngIf="currentUser  && !mobileView">
				<button id="user-pop-over" data-toggle="dropdown" class="user-icon-btn">
					<img *ngIf="!userPic" src="assets/img/user-profile.svg">
          <img *ngIf="userPic" src="{{userPic}}">
				</button>
				<div class="dropdown-menu" aria-labelledby="user-pop-over">
					<div class="dropdown-container">
						<div class="upper-container">
							<div class="name-pro">
								<h6>{{currentUser.firstName+" "+currentUser.lastName}}</h6>
								<span class="pro">
									{{planName}}
								</span>
							</div>
							<div class="email">{{currentUser.email}}</div>
							<div *ngIf="totalSpaceAllowed <= 1000 && consumedSpaceAllowed <= 1000" class="storage-size">{{consumedSpaceAllowed | number: '1.2-2'}}MB / {{totalSpaceAllowed}}GB</div>
              <div *ngIf="totalSpaceAllowed <= 1000 && consumedSpaceAllowed > 1000" class="storage-size">{{consumedSpaceAllowed/1000 | number: '1.2-2'}}GB / {{totalSpaceAllowed}}GB</div>
							<div *ngIf="totalSpaceAllowed > 1000 && consumedSpaceAllowed > 1000" class="storage-size">{{consumedSpaceAllowed/1000 | number: '1.2-2'}}GB / {{totalSpaceAllowed/1000}}TB</div>
							<!-- <div class="storage-indicator">
								<div class="storage-indicator-color">

								</div>
							</div> -->
							<progress id="file" value="{{consumedSpaceAllowed}}" max="{{totalSpaceAllowedProgress}}"></progress>
						</div>

						<ul class="dropdown-list list-group">
							<div class="hr-line"></div>
							<a routerLink="/my-profile"><li class="list-group-item">My profile</li></a>
							<a (click)="personalClick()"><li class="list-group-item">My content hub</li></a>
							<div class="hr-line"></div>
							<a routerLink="/how-it-works" target="_blank"><li class="list-group-item">How it works</li></a>
							<a routerLink="/home" target="_blank"><li class="list-group-item">Go to Homepage</li></a>
							<a (click)="goToMarketplace()"><li class="list-group-item">Go to Marketplace</li></a>
							<a routerLink="/feedbacks" target="_blank"><li class="list-group-item">Feedback & bugs report</li></a>
							<a routerLink="/faq" target="_blank"><li class="list-group-item">FAQ</li></a>
							<a *ngIf="planName == 'Free'">
								<li class="list-group-item" style="background-color: var(--primaryColorLightBlue); border-radius: 4px; margin-top: 8px; display: block;"><b style="color: #2d7cff">Upgrade plan:</b><span> You're on the free plan. Upgrade now for unlimited storage, access, members, and more.</span></li>
							</a>
						</ul>
						<div class="logout-btn">
							<button type="button" class="ant-btn" (click)="logOut()"><a>Logout</a></button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</header>

<section class="pricing-main-section" *ngIf="mainDetailSection">
  <div class="container">
    <div class="row">
      <div class="col-sm-12">
				<p>Easy & Affordable</p>
        <h2>Pricing</h2>
      </div>
    </div>
  </div>
</section>


<!-- Power Section -->
<section class="pricing-section" *ngIf="mainDetailSection">
	<div class="container">
		<div class="row">
		  <div class="col-sm-12 text-center">
		    <div class="switcher">
		      <span class="discount">25%</span>
					<input type="radio" name="subscriptionss" value="monthly" id="monthly" [checked]="radioMonthly"  (click)="monthly(); radioYearly=false; radioMonthly=true;">
					<label for="monthly">Monthly</label>
					<input type="radio" name="subscriptionss" value="yearly" id="yearly" [checked]="radioYearly" (click)="yearly(); radioMonthly=false; radioYearly=true;">
					<label for="yearly">Yearly</label>
		    </div>
		  </div>
		  <div class="col-sm-3" *ngFor="let membership of memberships | slice:0:3">
				<div class="plan-description" *ngIf="membership.title != 'Professional'">
					<span class="enterprise-current-plan" *ngIf="membership.title == 'Free' && planName == 'Free'">Active plan</span>

					<span class="enterprise-current-plan" *ngIf="membership.title != 'Free' && planName == membership.title">Active plan</span>
					<h4>{{membership.title}}</h4>
					<hr>
			    <p class="subtext">{{membership.description}}</p>
					<h3 *ngIf="yearlyPlanValue == false">${{membership.price_monthly*1}}<span>User/Month</span></h3>
					<h3 *ngIf="yearlyPlanValue == true">${{membership.price_yearly*1}}
						<del *ngIf="membership.title == 'Plus'">${{membership.allowed_plugin_count}}</del>
						<del *ngIf="membership.title == 'Free'"></del>
						<span>User/Month</span>
					</h3>
					<!-- plans-disable-btn -->
			    <a href="javascript:;" class="button get-for-free-btn" *ngIf="membership.title == 'Free' && planName == 'Free'">Get For Free</a>
					<a href="javascript:;" class="button get-for-free-btn" *ngIf="membership.title == 'Free' && planName != 'Free'">Get For Free</a>
					<a href="javascript:;" class="button get-for-free-btn" *ngIf="membership.title != 'Free' && planName == membership.title">Buy Now</a>
					<a href="javascript:;" class="button get-buy-now-btn" *ngIf="membership.title != 'Free' && planName != membership.title" (click)="getCurrentPlanDetails(membership)">Buy Now</a>
				</div>

				<div class="professional-description" *ngIf="membership.title == 'Professional'">
					<span><i>Recommended</i></span>
					<span class="enterprise-current-plan" *ngIf="planName != 'Free' && planName == 'Professional'">Active plan</span>
					<h4>{{membership.title}}</h4>
					<hr>
			    <p class="subtext">{{membership.description}}</p>
					<span class="more-space">More space for growing teams</span>
					<h3 *ngIf="yearlyPlanValue == false">${{membership.price_monthly*1}}<span>User/Month</span></h3>
					<h3 *ngIf="yearlyPlanValue == true">${{membership.price_yearly*1}} <del>${{membership.allowed_plugin_count}}</del><span>User/Month</span></h3>
					<!-- plans-disable-btn -->
					<a href="javascript:;" class="button get-for-free-btn" *ngIf="membership.title != 'Free' && planName == membership.title">Buy Now</a>
					<a href="javascript:;" class="button professional-buy-now" *ngIf="membership.title != 'Free' && planName != membership.title" (click)="getCurrentPlanDetails(membership)">Buy Now</a>
				</div>
		  </div>

		  <div class="col-sm-3">
				<div class="enterprise-description">
					<span class="enterprise-current-plan" *ngIf="planName != 'Free' && planName == 'Enterprise'">Active plan</span>
					<h4>Enterprise</h4>
					<hr>
			    <p class="subtext">For medium to large teams with 20+ members</p>
			    <h3>Let’s Chat<span>Contact Us</span></h3>
			    <a href="javascript:;" class="button enterprise-buy-now" (click)="openLetsTalkDialog(letsTalk)">Contact Sales</a>
				</div>
		  </div>
		</div>

		<div class="loader-scenarios" *ngIf="showTopRightLoader">
			<img class="img-up-loader" style="width: 30px;" src="assets/img/img-up.svg" alt="">
		</div>

		<div class="loader-scenarios-error-msgs" data-aos="fade-left" data-aos-easing="linear" data-aos-duration="200" *ngIf="sendSuccessfulErrorMsg">
			<p>{{sendSuccessfulErrorMessage}}</p>
		</div>

	</div>
</section>

<!-- Plugin Section -->
<section class="compareplan-section" *ngIf="mainDetailSection">
	<div class="container">
	  <div class="row">
	    <div class="col-sm-12 text-center">
	      <h2>Compare features & plans</h2>
	      <div class="price-table pricing-plan-details">
	        <table>
	          <tr>
	            <td></td>
	            <td *ngFor="let membership of memberships | slice:0:3">
	              <h4 class="membership-text">{{membership.title}}</h4>
								<a class="button disable-btn plans-disable-btn" *ngIf="membership.title == 'Free' && planName == 'Free'" href="javascript:;">Active Plan</a>
								<a *ngIf="membership.title == 'Free' && planName != 'Free'" href="javascript:;" class="button">Get For Free</a>
								<a class="button disable-btn plans-disable-btn" *ngIf="membership.title != 'Free' && planName == membership.title" href="javascript:;">Active Plan</a>
								<a *ngIf="membership.title != 'Free' && planName != membership.title" href="javascript:;" class="button" (click)="getCurrentPlanDetails(membership)">Buy Now</a>
							</td>
	            <td>
	              <h4>Enterprise</h4>
	              <a href="javascript:;" class="button" style="color: #000; background-color: #ffd364;" (click)="openLetsTalkDialog(letsTalk)">Contact Sales</a>
	            </td>
	          </tr>
	          <tr>
	            <td>
	              <span>Storage</span>
	            </td>
	            <td>
	              <span>3GB</span>
	            </td>
	            <td>
	              <span>200GB</span>
							</td>
							<td>
	              <span>4TB</span>
	            </td>
	            <td>
	              <span>Let’s Talk</span>
	            </td>
	          </tr>
						<tr>
							<td>
								<span>Users</span>
							</td>
							<td>
								<span>2</span>
							</td>
							<td>
								<span>5</span>
							</td>
							<td>
								<span>10</span>
							</td>
							<td>
								<span>Let’s Talk</span>
							</td>
						</tr>
						<tr>
							<td>
								<span>Workspace</span>
							</td>
							<td>
								<span>1 workspace</span>
							</td>
							<td>
								<span>2 workspaces</span>
							</td>
							<td>
								<span>5 workspaces</span>
							</td>
							<td>
								<span>Let’s Talk</span>
							</td>
						</tr>
						<tr>
							<td>
								<span>Mobile app</span>
							</td>
							<td>
								<p></p>
							</td>
							<td>
								<i class="fa fa-check" aria-hidden="true"></i>
							</td>
							<td>
								<i class="fa fa-check" aria-hidden="true"></i>
							</td>
							<td>
								<i class="fa fa-check" aria-hidden="true"></i>
							</td>
						</tr>

					</table>
				</div>

				<div class="plugin-table">
					<table>
						<tr>
						</tr>
						<tr>
							<td>
								<span>Figma</span>
							</td>
							<td>
								<i class="fa fa-check" aria-hidden="true"></i>
							</td>
							<td>
								<i class="fa fa-check" aria-hidden="true"></i>
							</td>
							<td>
								<i class="fa fa-check" aria-hidden="true"></i>
							</td>
							<td>
								<i class="fa fa-check" aria-hidden="true"></i>
							</td>
						</tr>
						<tr>
							<td>
								<span>Sketch</span>
							</td>
							<td>
								<i class="fa fa-check" aria-hidden="true"></i>
							</td>
							<td>
								<i class="fa fa-check" aria-hidden="true"></i>
							</td>
							<td>
								<i class="fa fa-check" aria-hidden="true"></i>
							</td>
							<td>
								<i class="fa fa-check" aria-hidden="true"></i>
							</td>
						</tr>
						<tr>
							<td>
								<span>Illustrator</span>
							</td>
							<td>
								<i class="fa fa-check" aria-hidden="true"></i>
							</td>
							<td>
								<i class="fa fa-check" aria-hidden="true"></i>
							</td>
							<td>
								<i class="fa fa-check" aria-hidden="true"></i>
							</td>
							<td>
								<i class="fa fa-check" aria-hidden="true"></i>
							</td>
						</tr>
						<tr>
							<td>
								<span>XD <a style="color: #ffd364; font-size: 12px;"><b>Coming soon</b></a></span>
							</td>
							<td>
								<i class="fa fa-check" aria-hidden="true"></i>
							</td>
							<td>
								<i class="fa fa-check" aria-hidden="true"></i>
							</td>
							<td>
								<i class="fa fa-check" aria-hidden="true"></i>
							</td>
							<td>
								<i class="fa fa-check" aria-hidden="true"></i>
							</td>
						</tr>
						<tr>
							<td>
								<span>Photoshop <a style="color: #ffd364; font-size: 12px;"><b>Coming soon</b></a></span>
							</td>
							<td>
								<i class="fa fa-check" aria-hidden="true"></i>
							</td>
							<td>
								<i class="fa fa-check" aria-hidden="true"></i>
							</td>
							<td>
								<i class="fa fa-check" aria-hidden="true"></i>
							</td>
							<td>
								<i class="fa fa-check" aria-hidden="true"></i>
							</td>
						</tr>
						<tr>
							<td>
								<span>JPEG, PNG, GIF & SVG support</span>
							</td>
							<td>
								<i class="fa fa-check" aria-hidden="true"></i>
							</td>
							<td>
								<i class="fa fa-check" aria-hidden="true"></i>
							</td>
							<td>
								<i class="fa fa-check" aria-hidden="true"></i>
							</td>
							<td>
								<i class="fa fa-check" aria-hidden="true"></i>
							</td>
						</tr>
						<tr>
							<td>
								<span>Video formats</span>
							</td>
							<td>
								<i class="fa fa-check" aria-hidden="true"></i>
							</td>
							<td>
								<i class="fa fa-check" aria-hidden="true"></i>
							</td>
							<td>
								<i class="fa fa-check" aria-hidden="true"></i>
							</td>
							<td>
								<i class="fa fa-check" aria-hidden="true"></i>
							</td>
						</tr>
					</table>
				</div>

				<div class="plugin-table">
					<table>
						<tr>
						</tr>
						<tr>
							<td>
								<span>File versioning</span>
							</td>
							<td>
								<p></p>
							</td>
							<td>
								<i class="fa fa-check" aria-hidden="true"></i>
							</td>
							<td>
								<i class="fa fa-check" aria-hidden="true"></i>
							</td>
							<td>
								<i class="fa fa-check" aria-hidden="true"></i>
							</td>
						</tr>
						<tr>
							<td>
								<span>Collaboration</span>
							</td>
							<td>
								<i class="fa fa-check" aria-hidden="true"></i>
							</td>
							<td>
								<i class="fa fa-check" aria-hidden="true"></i>
							</td>
							<td>
								<i class="fa fa-check" aria-hidden="true"></i>
							</td>
							<td>
								<i class="fa fa-check" aria-hidden="true"></i>
							</td>
						</tr>
						<tr>
							<td>
								<span>View-only members</span>
							</td>
							<td>
								<i class="fa fa-check" aria-hidden="true"></i>
							</td>
							<td>
								<i class="fa fa-check" aria-hidden="true"></i>
							</td>
							<td>
								<i class="fa fa-check" aria-hidden="true"></i>
							</td>
							<td>
								<i class="fa fa-check" aria-hidden="true"></i>
							</td>
						</tr>
						<tr>
							<td>
								<span>User comments</span>
							</td>
							<td>
								<p></p>
							</td>
							<td>
								<i class="fa fa-check" aria-hidden="true"></i>
							</td>
							<td>
								<i class="fa fa-check" aria-hidden="true"></i>
							</td>
							<td>
								<i class="fa fa-check" aria-hidden="true"></i>
							</td>
						</tr>
						<tr>
							<td>
								<span>Guest comments</span>
							</td>
							<td>
								<p></p>
							</td>
							<td>
								<i class="fa fa-check" aria-hidden="true"></i>
							</td>
							<td>
								<i class="fa fa-check" aria-hidden="true"></i>
							</td>
							<td>
								<i class="fa fa-check" aria-hidden="true"></i>
							</td>
						</tr>
					</table>
				</div>

				<div class="plugin-table">
					<table>
						<tr>
						</tr>
						<tr>
							<td>
								<span>Custom tags</span>
							</td>
							<td>
								<p></p>
							</td>
							<td>
								<i class="fa fa-check" aria-hidden="true"></i>
							</td>
							<td>
								<i class="fa fa-check" aria-hidden="true"></i>
							</td>
							<td>
								<i class="fa fa-check" aria-hidden="true"></i>
							</td>
						</tr>
						<tr>
							<td>
								<span>Admin & member editor roles</span>
							</td>
							<td>
								<p></p>
							</td>
							<td>
								<i class="fa fa-check" aria-hidden="true"></i>
							</td>
							<td>
								<i class="fa fa-check" aria-hidden="true"></i>
							</td>
							<td>
								<i class="fa fa-check" aria-hidden="true"></i>
							</td>
						</tr>
						<tr>
							<td>
								<span>Notifications</span>
							</td>
							<td>
								<i class="fa fa-check" aria-hidden="true"></i>
							</td>
							<td>
								<i class="fa fa-check" aria-hidden="true"></i>
							</td>
							<td>
								<i class="fa fa-check" aria-hidden="true"></i>
							</td>
							<td>
								<i class="fa fa-check" aria-hidden="true"></i>
							</td>
						</tr>
						<tr>
							<td>
								<span>Sharable links</span>
							</td>
							<td>
								<i class="fa fa-check" aria-hidden="true"></i>
							</td>
							<td>
								<i class="fa fa-check" aria-hidden="true"></i>
							</td>
							<td>
								<i class="fa fa-check" aria-hidden="true"></i>
							</td>
							<td>
								<i class="fa fa-check" aria-hidden="true"></i>
							</td>
						</tr>
						<tr>
							<td>
								<span>Download different file formats</span>
							</td>
							<td>
								<p></p>
							</td>
							<td>
								<i class="fa fa-check" aria-hidden="true"></i>
							</td>
							<td>
								<i class="fa fa-check" aria-hidden="true"></i>
							</td>
							<td>
								<i class="fa fa-check" aria-hidden="true"></i>
							</td>
						</tr>
						<tr>
							<td>
								<span>Admin approval</span>
							</td>
							<td>
								<i class="fa fa-check" aria-hidden="true"></i>
							</td>
							<td>
								<i class="fa fa-check" aria-hidden="true"></i>
							</td>
							<td>
								<i class="fa fa-check" aria-hidden="true"></i>
							</td>
							<td>
								<i class="fa fa-check" aria-hidden="true"></i>
							</td>
						</tr>
						<tr>
							<td>
								<span>Team management</span>
							</td>
							<td>
								<p></p>
							</td>
							<td>
								<i class="fa fa-check" aria-hidden="true"></i>
							</td>
							<td>
								<i class="fa fa-check" aria-hidden="true"></i>
							</td>
							<td>
								<i class="fa fa-check" aria-hidden="true"></i>
							</td>
						</tr>
					</table>
				</div>

				<div class="access-table">
					<table>
						<tr>
						</tr>
						<tr>
							<td>
								<span>Plugin assets settings</span>
							</td>
							<td>
								<p></p>
							</td>
							<td>
								<i class="fa fa-check" aria-hidden="true"></i>
							</td>
							<td>
								<i class="fa fa-check" aria-hidden="true"></i>
							</td>
							<td>
								<i class="fa fa-check" aria-hidden="true"></i>
							</td>
						</tr>
						<tr>
							<td>
								<span>Onboarding support</span>
							</td>
							<td>
								<p></p>
							</td>
							<td>
								<p></p>
							</td>
							<td>
								<i class="fa fa-check" aria-hidden="true"></i>
							</td>
							<td>
								<i class="fa fa-check" aria-hidden="true"></i>
							</td>
						</tr>
						<tr>
							<td>
								<span>Ongoing team training</span>
							</td>
							<td>
								<p></p>
							</td>
							<td>
								<p></p>
							</td>
							<td>
								<p></p>
							</td>
							<td>
								<i class="fa fa-check" aria-hidden="true"></i>
							</td>
						</tr>
						<tr>
							<td>
								<span>Dedicated account manager</span>
							</td>
							<td>
								<p></p>
							</td>
							<td>
								<p></p>
							</td>
							<td>
								<p></p>
							</td>
							<td>
								<i class="fa fa-check" aria-hidden="true"></i>
							</td>
						</tr>
						<tr>
	            <td>
	              <div class="switcher">
									<input type="radio" name="subscription" value="billyearly" id="billyearly" [checked]="year"  (click)="yearlyPlan();month=false; year=true;">
									<label for="billyearly">Bill Yearly</label>
									<input type="radio" name="subscription" value="billmonthly" id="billmonthly" [checked]="month"  (click)="monthlyPlan();year=false; month=true;">
									<label for="billmonthly">Bill Monthly</label>
	              </div>
	            </td>
							<td class="pricing-plan-details" *ngFor="let membership of membershipPlan | slice:0:3">
								<div class="title membership-text-amount">
									<h4 class="membership-text">{{membership.title}}</h4>
									<h3 *ngIf="yearlyValue == false">${{membership.price_monthly*1}} <span>User/Month</span></h3>
									<h3 *ngIf="yearlyValue == true">${{membership.price_yearly*1}} <span> User/Month</span></h3>
								</div>
								<a class="button disable-btn plans-disable-btn" *ngIf="membership.title == 'Free' && planName == 'Free'" href="javascript:;">Active Plan</a>
								<a *ngIf="membership.title == 'Free' && planName != 'Free'" href="javascript:;" class="button">Get For Free</a>
								<a class="button disable-btn plans-disable-btn" *ngIf="membership.title != 'Free' && planName == membership.title" href="javascript:;">Active Plan</a>
								<a *ngIf="membership.title != 'Free' && planName != membership.title" href="javascript:;" class="button" (click)="getCurrentPlanDetails(membership)">Buy Now</a>
							</td>
	            <td>
	              <div class="title membership-text-amount">
	                <h4 class="membership-text">Enterprise</h4>
									<h3>Let's chat</h3>
	              </div>
	              <a href="javascript:;" class="button" style="color: #000; background-color: #ffd364; margin-top: 16px;" (click)="openLetsTalkDialog(letsTalk)">Contact Us</a>
	            </td>
	          </tr>
					</table>
				</div>
	    </div>
	  </div>
	</div>
</section>

<section class="price-power-section" *ngIf="priceDetailsSection">
	<div class="container">
		<div class="panel-wrapper">
			<div class="left-panel">
			  <div class="box-wrapper mb-4">
			    <div class="d-flex">
			      <div class="img-wrpper">
			        <img src="assets/img/christmas.png">
			      </div>
			      <div class="content-wrapper">
			        <h3 class="mb-0 pb-0">Ready for Crafttor {{selectedMembership.title}}?</h3>
			        <p class="upgrade-txt">Upgrade your plan and get:</p>
			        <ul>
			          <li><strong>Unlimited</strong> user billed at ${{selectedMembership.price_yearly*12}}/user/year</li>
								<li *ngIf="selectedMembership.allowed_workspace_count == 1"><strong>{{selectedMembership.allowed_workspace_count}}</strong> Workspace</li>
								<li *ngIf="selectedMembership.allowed_workspace_count > 1"><strong>{{selectedMembership.allowed_workspace_count}}</strong> Workspaces</li>
								<li *ngIf="selectedMembership.allowed_admin_count == 1"><strong>{{selectedMembership.allowed_admin_count}}</strong> Admin</li>
								<li *ngIf="selectedMembership.allowed_admin_count > 1"><strong>{{selectedMembership.allowed_admin_count}}</strong> Admins</li>
			          <li><strong>Unlimited</strong> boards</li>
			          <li *ngIf="selectedMembership.title == 'Plus'"><strong>{{selectedMembership.space/1000}} GB</strong> of storage.</li>
								<li *ngIf="selectedMembership.title == 'Professional'"><strong>{{selectedMembership.space/1000000}} TB</strong> of storage.</li>
								<li><strong>{{addUserCount}}</strong> seats(including owner).</li>
			        </ul>
			      </div>
			    </div>
			  </div>

				<div class="box-wrapper mb-4">
					<div class="containers" style="display:flex">
						<div class="">
							<h3 class="mb-0 pb-0">Add Users</h3>
							<p class="bring-text">Bring more people into the workspace</p>
						</div>
						<div class="add-more-users" style="margin-left:auto;">
							<div class="add-sub-icon" (click)="userCountDike(addUserCount, totalPriceFixed, selectedMembership)">
								<button type="button" class="button-checkout-icon-add button-checkout-icon">
									<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" class="svg-icon"><g id="Web---Filled" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round"><g id="Web/Filled/16x16/minus" stroke="currentColor" stroke-width="1.5"><path id="Path-4" d="M2.75 8.25h11"></path></g></g></svg>
								</button>
								</div>

								<div class="add-sub-icon-borderless">
									<button type="button" class="button-checkout-icon-add button-checkout-icon">
										<h6><strong>{{addUserCount}}</strong></h6>
									</button>
									</div>

								<div class="add-sub-icon" (click)="userCountHike(addUserCount, totalPriceFixed, selectedMembership)">
									<button type="button" class="button-checkout-icon-add button-checkout-icon">
										<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" class="svg-icon"><g id="16x16/Filled/Plus" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><path d="M8.25 2a.75.75 0 01.75.75V7.5h4.75a.75.75 0 110 1.5H9v4.75a.75.75 0 11-1.5 0V8.999L2.75 9a.75.75 0 010-1.5l4.75-.001V2.75A.75.75 0 018.25 2z" id="plus" fill="currentColor" fill-rule="nonzero"></path></g></svg>
									</button>
								</div>
							</div>
					</div>
				</div>
				<p class="error" style="font-size: 12px; color: #ff0000; margin-top: -20px;" *ngIf="showMaxSeatsReached">{{showSeatsErrorText}}</p>
				<button id="create-workspace" data-toggle="dropdown" class="DAM-icon back-to-payment" (click)="showMainSection()">
					<a class="navbar-brand js-scroll-trigger" href="javascript:;"><svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
							<title>Back</title>
							<g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
									<g id="DAM-Pricing-Copy-2" transform="translate(-40.000000, -28.000000)">
											<g id="Back" transform="translate(40.000000, 28.000000)">
													<rect id="Rectangle-8" x="0" y="0" width="24" height="24"></rect>
													<g id="Group-7" stroke-linecap="round" stroke-linejoin="round" transform="translate(3.000000, 6.000000)" stroke="#000000" stroke-width="1.5">
															<line x1="0" y1="6" x2="17.1428571" y2="6" id="Stroke-1"></line>
															<polyline id="Path-2" points="5.4 0 0 5.9256575 5.27460736 12"></polyline>
													</g>
											</g>
									</g>
							</g>
					</svg>
				</a>
					<span class="drop-down-option-workspace" style="margin-left: -10px;">
						Back
					</span>
				</button>
			</div>
			<div class="right-panel">
			  <div class="box-wrapper">
			    <div class="plane-summary">
			      <h3>Plan summary</h3>
			      <table>
			        <tbody>
			        	<tr>
			            <td>
			              <input type="radio" name="subscription" value="yearly" id="yearly" [checked]="detailsYearly" (click)="chooseYearly()">
			               <label for="yearly">
											 Yearly
											 <div class="badge">Save 25%</div>
										 </label>
			             </td>
			             <td>
			               <div class="price">${{selectedMembership.price_yearly*1}}/month</div>
			             </td>
			           </tr>
			            <tr>
			              <td colspan="2" class="coupon-box">
			              <a class="link-btn" data-toggle="collapse" href="#multiCollapseExample1" role="button" aria-expanded="false" aria-controls="multiCollapseExample1" (click)="hideErroMsg()">Have a coupon code?</a>
			              <div class="collapse multi-collapse" id="multiCollapseExample1">
			                <div class="input-group">
			                <input type="text" class="form-control coupon" maxlength="20" placeholder="Coupon code" type="text" value="" [(ngModel)]="couponcode" required>
			                  <span class="input-group-append">
			                    <button class="btn btn-primary btn-apply coupon" [disabled]="couponcode === ''" (click)="applyCouponCode()">{{couponBtnText}}</button>
			                  </span>
			                </div>
											<p *ngIf="showCouponCodeError" class="coupon-error-txt">{{couponCodeErrorMsg}}</p>
			              </div>
			              </td>
			            </tr>
			          <tr class="user">
			            <td><p>{{addUserCount}} user on annual plan</p></td>
			            <td>
			              <p class="small">${{totalPriceFixed}}</p>
			            </td>
			          </tr>

			          <tr class="total">
			            <td><div class="price" style="margin-top: 16px;"><h4 style="padding-bottom: 0px;">Total</h4></div></td>
			            <td>
			              <div class="price" style="margin-top: 16px;"><h4 style="padding-bottom: 0px;">${{totalPriceFixed}}</h4></div>
			            </td>
			          </tr>
			          <tr class="button-wrapper">
			            <td colspan="2" >
			               <a class="button" href="javascript:;" (click)="createRzpayOrder(selectedMembership.price_yearly*12, 'usd', selectedMembership)" *ngIf="!isShowError">Upgrade</a>
										 <a class="disable-btn" href="javascript:;" *ngIf="isShowError">Upgrade</a>
			            </td>
			          </tr>
			          <tr>
			            <td colspan="2">
			              <p class="small" style="font-size: 12px;">By confirming your subscription, you allow Crafttor to charge your card for this payment in accordance with their terms.</p>
			            </td>
			          </tr>
			        </tbody>
			      </table>
			    </div>
			  </div>
			</div>
		</div>
	</div>
</section>

<section class="price-power-section" *ngIf="planUpgradeSection">
<div class="container">
<div class="panel-wrapper">
<div class="left-panel">
  <div class="box-wrapper mb-4">
    <div class="d-flex">
      <div class="img-wrpper">
        <img src="assets/img/christmas.png">
      </div>
      <div class="content-wrapper">
        <h3 class="mb-0 pb-0">Ready for Crafttor {{selectedMembership.title}}?</h3>
        <p class="upgrade-txt">Upgrade your plan and get:</p>
        <ul>
          <li><strong>Unlimited</strong> user billed at ${{selectedMembership.price_yearly*12}}/user/year</li>
					<li *ngIf="selectedMembership.allowed_workspace_count == 1"><strong>{{selectedMembership.allowed_workspace_count}}</strong> Workspace</li>
					<li *ngIf="selectedMembership.allowed_workspace_count > 1"><strong>{{selectedMembership.allowed_workspace_count}}</strong> Workspaces</li>
					<li *ngIf="selectedMembership.allowed_admin_count == 1"><strong>{{selectedMembership.allowed_admin_count}}</strong> Admin</li>
					<li *ngIf="selectedMembership.allowed_admin_count > 1"><strong>{{selectedMembership.allowed_admin_count}}</strong> Admins</li>
					<li><strong>Unlimited</strong> boards</li>
          <li *ngIf="selectedMembership.title == 'Plus'"><strong>{{selectedMembership.space/1000}} GB</strong> of storage.</li>
					<li *ngIf="selectedMembership.title == 'Professional'"><strong>{{selectedMembership.space/1000000}} TB</strong> of storage.</li>
					<li><strong>{{addUserCount}}</strong> seats(including owner).</li>
        </ul>
      </div>
    </div>
  </div>

	<div class="box-wrapper mb-4">
		<div class="containers" style="display:flex">
			<div class="">
				<h3 class="mb-0 pb-0">Add Users</h3>
				<p class="bring-text">Bring more people into the workspace</p>
			</div>
			<div class="add-more-users" style="margin-left:auto;">
				<div class="add-sub-icon">
					<button (click)="userPlanUpgradeCountDike(addUserCount, totalPriceFixed)" type="button" class="button-checkout-icon-add button-checkout-icon">
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" class="svg-icon"><g id="Web---Filled" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round"><g id="Web/Filled/16x16/minus" stroke="currentColor" stroke-width="1.5"><path id="Path-4" d="M2.75 8.25h11"></path></g></g></svg>
					</button>

					<!-- <button *ngIf="isIndiaProrata" (click)="userPlanUpgradeCountDikeRazor(addUserCount, totalPriceFixed)" type="button" class="button-checkout-icon-add button-checkout-icon">
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" class="svg-icon"><g id="Web---Filled" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round"><g id="Web/Filled/16x16/minus" stroke="currentColor" stroke-width="1.5"><path id="Path-4" d="M2.75 8.25h11"></path></g></g></svg>
					</button> -->
					</div>

					<div class="add-sub-icon-borderless">
						<button type="button" class="button-checkout-icon-add button-checkout-icon">
							<h6><strong>{{addUserCount}}</strong></h6>
						</button>
						</div>

					<div class="add-sub-icon">
						<button (click)="userPlanUpgradeCountHike(addUserCount, totalPriceFixed)" type="button" class="button-checkout-icon-add button-checkout-icon">
							<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" class="svg-icon"><g id="16x16/Filled/Plus" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><path d="M8.25 2a.75.75 0 01.75.75V7.5h4.75a.75.75 0 110 1.5H9v4.75a.75.75 0 11-1.5 0V8.999L2.75 9a.75.75 0 010-1.5l4.75-.001V2.75A.75.75 0 018.25 2z" id="plus" fill="currentColor" fill-rule="nonzero"></path></g></svg>
						</button>

						<!-- <button *ngIf="isIndiaProrata" (click)="userPlanUpgradeCountHikeRazor(addUserCount, totalPriceFixed)" type="button" class="button-checkout-icon-add button-checkout-icon">
							<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" class="svg-icon"><g id="16x16/Filled/Plus" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><path d="M8.25 2a.75.75 0 01.75.75V7.5h4.75a.75.75 0 110 1.5H9v4.75a.75.75 0 11-1.5 0V8.999L2.75 9a.75.75 0 010-1.5l4.75-.001V2.75A.75.75 0 018.25 2z" id="plus" fill="currentColor" fill-rule="nonzero"></path></g></svg>
						</button> -->
					</div>
				</div>
		</div>

	</div>

	<button id="create-workspace" data-toggle="dropdown" class="DAM-icon back-to-payment" (click)="showMainSection()">
		<a class="navbar-brand js-scroll-trigger" href="javascript:;"><svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
				<title>Back</title>
				<g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
						<g id="DAM-Pricing-Copy-2" transform="translate(-40.000000, -28.000000)">
								<g id="Back" transform="translate(40.000000, 28.000000)">
										<rect id="Rectangle-8" x="0" y="0" width="24" height="24"></rect>
										<g id="Group-7" stroke-linecap="round" stroke-linejoin="round" transform="translate(3.000000, 6.000000)" stroke="#000000" stroke-width="1.5">
												<line x1="0" y1="6" x2="17.1428571" y2="6" id="Stroke-1"></line>
												<polyline id="Path-2" points="5.4 0 0 5.9256575 5.27460736 12"></polyline>
										</g>
								</g>
						</g>
				</g>
		</svg>
	</a>
		<span class="drop-down-option-workspace" style="margin-left: -10px;">
			Back
		</span>
	</button>
</div>
<div class="right-panel">
  <div class="box-wrapper">
    <div class="plane-summary">
      <h3>Plan summary</h3>
      <table>
        <tbody>
              <tr>
                <td>
                  <input type="radio" name="subscription" value="yearly" id="yearly" [checked]="detailsYearly" (click)="chooseYearly()">
                  <label for="yearly">Yearly
										<div class="badge">Save 25%</div>
									</label>
                </td>
                <td>
                  <!-- <div class="price" *ngIf="isIndia">{{selectedMembership.amount_text.INR.now}}</div> -->
                  <div class="price">${{selectedMembership.price_yearly*1}}/month</div>
                </td>
              </tr>
            <tr>
              <td colspan="2" class="coupon-box">
              <!-- <a class="link-btn" data-toggle="collapse" href="#multiCollapseExample1" role="button" aria-expanded="false" aria-controls="multiCollapseExample1">Have a coupon code?</a> -->
              <div class="collapse multi-collapse" id="multiCollapseExample1">
                <div class="input-group">
                <input type="text" class="form-control coupon" name="" placeholder="Coupon code">
                  <span class="input-group-append">
                    <button class="btn btn-primary btn-apply coupon">Apply</button>
                  </span>
                </div>
              </div>
              </td>
            </tr>
          <tr class="user">
            <td><p>{{addUserCount}} user on this plan</p></td>
            <td>
              <!-- <p class="small" *ngIf="isIndia">${{selectedMembership.amount.INR*12}}</p> -->
              <p class="small"><b>${{totalPriceFixedPlanUpgrade}}</b></p>
            </td>
          </tr>

          <tr class="total">
            <td><p>Total</p></td>
            <td>
              <!-- <div class="price" *ngIf="isIndia">${{selectedMembership.amount.INR*12}}</div> -->
              <div class="price"><h4>${{totalPriceFixedPlanUpgrade}}</h4></div>
            </td>
          </tr>
					<!-- <tr class="total">
						<td>
							<p class="small"><b>Select Country</b></p>
							<div class="switcher" style="text-align: left; margin-top: 10px">
								<input type="radio" name="subscriptionss" value="indias" id="indias" [checked]="radioIndiaProrata"  (click)="chooseIndiaProrata(); radioOthersProrata=false; radioIndiaProrata=true;">
								<label for="monthly">India</label>
							</div>
						</td>
						<td>
							<p class="small"><b></b></p>
							<div class="switcher" style="text-align: left; margin-top: 30px">
								<input type="radio" name="subscriptionss" value="otherss" id="otherss" [checked]="radioOthersProrata" (click)="chooseOthersProrata(); radioIndiaProrata=false; radioOthersProrata=true;">
								<label for="yearly">Others</label>
							</div>
						</td>
					</tr> -->
					<!-- <tr>
            <td colspan="2" style="text-align: left;">
              <p class="small"><b>Note: </b>For users other than India, please select others option to pay.</p>
            </td>
          </tr> -->
          <tr class="button-wrapper">
						<!-- *ngIf="isIndiaProrata" -->
            <td colspan="2">
							<a class="button" href="javascript:;" (click)="createRzpayOrderUpgrade(totalPriceFixedPlanUpgrade, 'usd', selectedMembership)" *ngIf="!isShowError">Upgrade</a>
							<a class="disable-btn" href="javascript:;" *ngIf="isShowError">Upgrade</a>
            </td>

						<!-- Stripe Code -->
						<!-- <td colspan="2">
              <a class="button" href="javascript:;" (click)="checkoutStripeUpgradePlan(totalPriceFixedPlanUpgrade, 'usd', selectedMembership)" *ngIf="!isShowError">Upgrade</a>

							<a class="disable-btn" href="javascript:;" *ngIf="isShowError">Upgrade</a> -->

							<!-- Chargebee Code -->
							<!-- <a class="button" href="javascript:;" (click)="showPaymentPage(planUpGradePrice, 'usd', selectedMembership)">Upgrade</a> -->
            <!-- </td> -->
          </tr>
          <tr>
            <td colspan="2">
              <p class="small" style="font-size: 12px;">By confirming your subscriptions, you allow Crafttor to charge your card for this payment in accordance with their terms.</p>
              <!-- <p class="error">Your card number is invalid</p> -->
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
</div>
</div>
</section>

<section class="payment-success-section" *ngIf="paymentSuccessSection">
	<div class="container">
		<div class="row">
			<div class="img-container">
				<img src="assets/img/confirmed.svg">
				<h1>${{totalPriceFixed}}/-</h1>
				<h5>Your Payment is Successful!</h5>
				<p>Payment details are sent to your email.</p>
				<a href="javascript:;" class="button" (click)="switchToWorkspace()">Go to Workspace</a>
			</div>
		</div>
	</div>
</section>

<section class="faq-section-top-subscribe" *ngIf="hideFaq">
  <div class="container">
    <div class="row">
      <div class="col-sm-12">
        <div class="inner-content">
          <h2>FAQs</h2>
          <hr>
        </div>
      </div>
    </div>
  </div>
  </section>

<section class="faq-section-subscribe" *ngIf="hideFaq">
  <div class="container">
		<div class="row">
      <div class="col-sm-12">
        <div class="inner-content">
          <h3>What does Crafttor Workspace do?</h3>
          <p>Crafttor Workspace is a cloud storage which allows creators to store their files/assets and makes it very easy to organise, share, collaborate their creatives with individuals or teams anytime or anywhere they want.</p>
        </div>
      </div>
    </div>
		<hr>
    <div class="row">
      <div class="col-sm-12">
        <div class="inner-content">
          <h3>How will Crafttor make my team more organised?</h3>
          <p>Your team can work anytime and any number of hours. They is no restriction of hours per day per team member. A team member can create boards, upload & organise assets.</p>
        </div>
      </div>
    </div>
		<hr>
		<div class="row">
      <div class="col-sm-12">
        <div class="inner-content">
          <h3>What about the quality when I move assets within Crafttor?</h3>
          <p>Your assets will always be in original state. We do not compress the asset while moving within Crafttor. We only move the original assets within boards.</p>
        </div>
      </div>
    </div>
		<hr>
		<div class="row">
      <div class="col-sm-12">
        <div class="inner-content">
          <h3>Where can I upload assets from?</h3>
          <p>Currently, we allow our users to upload assets from their system. However, we have not yet created any external app links to import or upload assets.
					<br>We are working to enable Dropbox and Google Drive sync for importing and uploading assets.</p>
        </div>
      </div>
    </div>
		<hr>
		<div class="row">
      <div class="col-sm-12">
        <div class="inner-content">
          <h3>What file formats Crafttor Workspace support?</h3>
          <p>From SVG to PNG, GIF to BMP. Crafttor Workspace is a great platform that supports number of formats. It also includes video formats MP4 to WEBM, FLV to WMV and more. There are some rare formats which Crafttor Workspace do not support.</p>
        </div>
      </div>
    </div>
		<hr>
		<div class="row">
      <div class="col-sm-12">
        <div class="inner-content">
          <h3>What are the benefits of subscribing to Workspace?</h3>
          <p>Subscribing to Workspace unlocks a range of benefits, including access to more storage space, more number of workspaces and admin seats, early access to new features, premium content, and priority support.</p>
        </div>
      </div>
    </div>
		<hr>
		<div class="row">
      <div class="col-sm-12">
        <div class="inner-content">
          <h3>How much does a subscription to Crafttor Workspace cost?</h3>
          <p>The cost of a subscription to Crafttor Workspace varies depending on the plan you choose. We offer different subscription tiers to accommodate various preferences and budgets.</p>
        </div>
      </div>
    </div>
		<hr>
		<div class="row">
      <div class="col-sm-12">
        <div class="inner-content">
          <h3>Do I need to create an account to subscribe?</h3>
          <p>Yes, to subscribe to our service, you will need to create an account. This allows us to provide you with a personalized experience and manage your subscription.</p>
        </div>
      </div>
    </div>
		<hr>
		<div class="row">
      <div class="col-sm-12">
        <div class="inner-content">
          <h3>Is my payment information secure?</h3>
          <p>Yes, we take your payment security seriously. We use secure payment processing methods to protect your personal and financial information.</p>
        </div>
      </div>
    </div>
		<hr>
		<div class="row">
      <div class="col-sm-12">
        <div class="inner-content">
          <h3>Can I share my subscription with others?</h3>
          <p>Subscriptions to Crafttor Workspace are intended for individual use and cannot be shared with others. Sharing accounts may result in the suspension of your subscription. A user can add admin and member seats within subscription plan to share their work(assets, files, etc).</p>
        </div>
      </div>
    </div>
		<hr>
		<div class="row">
      <div class="col-sm-12">
        <div class="inner-content">
          <h3>Can I upgrade my subscription plan?</h3>
          <p>Yes, you can upgrade your subscription plan at any time. Visit upgrade section to make the change and access new features within the new plan.</p>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Footer -->
<footer class="site-footer" *ngIf="mainDetailSection">
  <div class="container">
  <div class="row">
    <div class="col-sm-3">
      <div class="coulmn-1">
				<img src="assets/img/logo.svg">
				<p>Digital assets management</p>
				<a href="mailto:info@crafttor.com"><i class="fa fa-envelope" aria-hidden="true"></i> info@crafttor.com</a>
			</div>
    </div>
    <!-- 3 -->
    <div class="col-sm-2">
      <h5>Products</h5>
      <ul class="menu">
        <li><a routerLink="/home" target="_blank">Workspace</a></li>
        <li><a (click)="goToMarketplace()">Marketplace</a></li>
        <li><a routerLink="/features" target="_blank">Features</a></li>
				<li><a routerLink="/mobile-apps" target="_blank">Crafttor for Mobile</a></li>
        <li><a routerLink="/smart-storage" target="_blank">Smart storage</a></li>
        <li><a routerLink="/effective-search" target="_blank">Effective search</a></li>
      </ul>
    </div>

    <div class="col-sm-2">
      <h5>Plugins</h5>
      <ul class="menu">
        <li><a href="javascript:;" href="https://www.figma.com/community/plugin/902086023682633830/Crafttor" target="_blank">Figma</a></li>
        <li><a href="javascript:;" href="https://crafttor.com/sketch" target="_blank">Sketch</a></li>
        <li><a href="javascript:;" href="https://exchange.adobe.com/apps/cc/109306/crafttor-for-illustrator" target="_blank">Illustrator</a></li>
				<li><a href="https://www.figma.com/community/plugin/1408354139656199596/kaleidoscope" target="_blank">Kaleidoscope</a></li>
				<li><a href="https://www.figma.com/community/plugin/1406167507218530657/iso-all" target="_blank">Iso All</a></li>
				<li><a href="https://www.figma.com/community/plugin/1409844094149025473/translate-ai" target="_blank">Translate AI</a></li>
				<li><a href="https://www.figma.com/community/plugin/1417763374654877658/image-to-figma-design-beta" target="_blank">Image to Figma</a></li>
				<li><a href="https://www.figma.com/community/plugin/1409553168281102402/bannners" target="_blank">Bannners</a></li>
      </ul>
    </div>

		<div class="col-sm-2">
			<h5>Solutions</h5>
			<ul class="menu">
				<li><a routerLink="/dropbox-alternative" target="_blank">Dropbox alternative</a></li>
				<li><a routerLink="/google-drive-alternative" target="_blank">G Drive alternative</a></li>
				<li><a routerLink="/box-alternative" target="_blank">Box alternative</a></li>
				<li><a routerLink="/content-library" target="_blank">Content library</a></li>
				<li><a routerLink="/user-profiling" target="_blank">User Profiling</a></li>
				<li><a routerLink="/approvals" target="_blank">Creative approvals</a></li>
			</ul>
		</div>

    <div class="col-sm-2">
      <h5>Features</h5>
      <ul class="menu">
        <li><a routerLink="/features/tagging" target="_blank">Tagging</a></li>
        <li><a routerLink="/features/sharing" target="_blank">Sharing</a></li>
        <li><a routerLink="/features/versioning" target="_blank">Versioning</a></li>
        <li><a routerLink="/features/collaboration" target="_blank">Collaboration</a></li>
        <li><a routerLink="/features/integration" target="_blank">Integration</a></li>
      </ul>
    </div>

    <div class="col-sm-2">
      <h5>Company</h5>
      <ul class="menu">
				<li><a routerLink="/about-workspace" target="_blank">About Workspace</a></li>
				<li><a routerLink="/contact" target="_blank">Contact Us</a></li>
        <li><a routerLink="/terms" target="_blank">Terms & Conditions</a></li>
        <li><a routerLink="/faq" target="_blank">FAQ</a></li>
        <li><a routerLink="/feedbacks" target="_blank">Feedback</a></li>
				<li><a href="https://crafttor.com/blogs" target="_blank">Blog</a></li>
				<li><a routerLink="/our-mission" target="_blank">Our mission</a></li>
				<li><a routerLink="/partner-with-us" target="_blank">Partner with us</a></li>
      </ul>
    </div>

    <div class="col-sm-3 all-social-icons">
      <h5>Socials</h5>
				<ul class="social-icons">
					<li><a rel="nofollow" href="https://www.facebook.com/Crafttor-Studio-102023868185724/?modal=admin_todo_tour" target=”_blank”
            alt="facebook"><i class="fa fa-facebook" aria-hidden="true"></i></a></li>
					<li><a rel="nofollow" href="https://twitter.com/CrafttorS" target=”_blank” alt="twitter"><i class="fa fa-twitter" aria-hidden="true"></i></a></li>
					<li><a rel="nofollow" href="https://www.linkedin.com/company/crafttor/" target=”_blank” alt="linkedin"><i class="fa fa-linkedin" aria-hidden="true"></i></a></li>
					<li><a rel="nofollow" href="https://www.instagram.com/crafttorstudio/" target=”_blank” alt="instagram"><i class="fa fa-instagram" aria-hidden="true"></i></a></li>
					<li><a rel="nofollow" href="https://www.youtube.com/channel/UC6SM1D8MU7uwLVEC8uFDW-w/?guided_help_flow=5" target=”_blank” alt="youtube"><i class="fa fa-youtube-play" aria-hidden="true"></i></a></li>
					<li><a rel="nofollow" href="https://dribbble.com/crafttorstudio" target=”_blank” alt="dribbble"><i class="fa fa-dribbble" aria-hidden="true"></i></a></li>
					<li><a rel="nofollow" href="https://www.behance.net/crafttorstudio" target=”_blank” alt="behance"><i class="fa fa-behance" aria-hidden="true"></i></a></li>
				</ul>
    </div>

    <div class="col-sm-12 text-center">
			<small>&copy; 2025 Crafttor. All rights reserved</small>
		</div>
  </div>
  </div>
</footer>

<ng-template #letsTalk let-letsTalk>
    <div class="custom-dialog custom-dialog-centered sign-up" role="document">
      <div class="modal-content">
        <div class="modal-body">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <img src="assets/img/cross.svg" (click)="letsTalk.close()">
          </button>
        <div class="modal-body">
      <h2>Let's talk!</h2>
      <p>Schedule a free demo today. We will show you a demo of how Crafttor Workspace works.</p>
      <div class="form-wrapper">
        <form class="row g-3" [formGroup]="letsTalkForm" (ngSubmit)="submitContactUs(selectDate)">
          <div class="col-md-6">
          <label class="form-label">First Name<span>*</span></label>
          <input id="textinput" formControlName="name" type="text" placeholder="Brian" class="form-control input-md" required>
          <span class="text-danger error-text"
          *ngIf="(letsTalkForm.controls.name.touched || submitted) && letsTalkForm.controls.name.errors?.required">
          First Name is required
        </span>
          </div>
          <div class="col-md-6">
          <label class="form-label">Last Name<span>*</span></label>
          <input id="textinput" formControlName="lname" type="text" placeholder="Storm" class="form-control input-md" required>
          <span class="text-danger error-text"
          *ngIf="(letsTalkForm.controls.lname.touched || submitted) && letsTalkForm.controls.lname.errors?.required">
          Last Name is required
        </span>
          </div>
          <div class="col-12">
          <label for="businessEmail" class="form-label">Business Email<span>*</span></label>
          <input id="textinput" formControlName="email" type="email" placeholder="abc@crafttor.com" class="form-control input-md" >
          <span class="text-danger error-text"
          *ngIf="(letsTalkForm.controls.email.touched || submitted) && letsTalkForm.controls.email.errors?.required">
          Email is required
        </span>
        <span class="text-danger error-text"
        *ngIf="(letsTalkForm.controls.email.touched || submitted) && letsTalkForm.controls.email.errors?.pattern">
        Email is not valid
      </span>
          </div>
          <div class="col-12">
          <label for="company" class="form-label">Company<span>*</span></label>
          <input id="textinput" formControlName="company" type="text" placeholder="Crafttor" class="form-control input-md" >
					<span class="text-danger error-text"
          *ngIf="(letsTalkForm.controls.company.touched || submitted) && letsTalkForm.controls.company.errors?.required">
          Company Name is required
        </span>
          </div>

          <div class="col-md-12" style="display: none;">
            <label class="form-label" for="textarea">Message</label>
            <input id="textinput" formControlName="message" type="text" class="form-control input-md" required>
            <span class="text-danger error-text"
            *ngIf="(letsTalkForm.controls.message.touched || submitted) && letsTalkForm.controls.message.errors?.required">
            Message is required
          </span>
          </div>


          <div class="col-12">
          <button id="singlebutton" name="singlebutton button" class="btn btn-primary" *ngIf="!showLeaveLoader">Submit</button>
					<button id="singlebutton" name="singlebutton button" class="btn btn-primary" *ngIf="showLeaveLoader"><img src="assets/img/img-up-white.svg" alt="" style="height: 18px;"></button>
          </div>
        </form>
      </div>
      <p>By Submiting the form, You agree to our <a routerLink="/terms" target="_blank">Terms of Service</a> and acknowledge our <a routerLink="/terms" target="_blank">Privacy Policy</a>.</p>
        </div>
      </div>
    </div>
    </div>
</ng-template>


<ng-template #selectDate let-selectDate>
    <div class="custom-dialog custom-dialog-centered select-time-popup" role="document">
      <div class="modal-content">
        <div class="modal-body">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <img src="assets/img/cross.svg" (click)="selectDate.close()">
          </button>
        <div class="modal-body">
      <h6>{{thankYouText}}</h6>
			<h6>(IST)</h6>
      <div class="form-wrapper">
				<ul class="date-listing" *ngFor="let slots of availableSlots | slice:1:5; let i = index">
					<li *ngIf="showDate">
						<div class="date-list" (click)="selectDateSales(slots.date, slots.day, slots.month)">
							<!-- <div class="date-list-day" style="background: #f9f9f9">
								<a href="javascript:;">{{slots.day}}</a>
							</div> -->
							<div class="">
								<a href="javascript:;">{{slots.month}} {{slots.date1}}</a>
							</div>
							<!-- <a href="javascript:;">{{slots.month}}</a> -->
						</div>
					</li>
				</ul>

				<div *ngIf="!showDate" class="selected-date">
					<div class="date-list-days">
						<a href="javascript:;">{{shownDay}}</a>
					</div>
					<div style="padding-top:10px;" class="">
						<a href="javascript:;">{{shownDate}}</a>
					</div>
					<!-- <a href="javascript:;">{{shownMonth}}</a> -->
				</div>

				<p *ngIf="!showDate" (click)="changeDate()" class="change-date-txt">Change Date</p>

				<h6 style="margin-top:20px;" *ngIf="showTime">What time works?</h6>

				<ul *ngFor="let time of availableTimeSlots; let i = index">
					<li *ngIf="showTime">
						<div class="time-list" (click)="selectTimeSales(time)">
							<div style="text-align: center;" class="">
								<a href="javascript:;">{{time}}</a>
							</div>
						</div>
					</li>
				</ul>
				<div *ngIf="showFinalTime" style="text-align: center;" class="selected-time">
					<a href="javascript:;">{{shownTime}}</a>
				</div>
				<p *ngIf="!showTime" (click)="changeTime()" class="change-time-txt"></p>
				<button id="singlebutton" name="singlebutton button" class="btn btn-primary" *ngIf="!timeSelected && !dateSelected && showSubmitBtn" (click)="contactSalesCall(thankyou)">Submit</button>
				<button id="singlebutton" name="singlebutton button" class="btn btn-primary" *ngIf="!timeSelected && dateSelected && showSubmitBtn" (click)="contactSalesCall(thankyou)">Submit</button>
				<button id="singlebutton" name="singlebutton button" class="btn btn-primary" *ngIf="timeSelected && !dateSelected && showSubmitBtn" (click)="contactSalesCall(thankyou)">Submit</button>
				<button id="singlebutton" name="singlebutton button" class="btn btn-primary" (click)="contactSalesCall(thankyou); selectDate.close()" *ngIf="timeSelected && dateSelected && showSubmitBtn">Submit</button>
				<p *ngIf="showSelectionMessage" class="text-danger error-text" style="text-align: center; margin-top:10px; font-weight: 600">{{showSelectedMsg}}</p>
      </div>
      <p>By Submiting the form, You agree to our <a routerLink="/terms" target="_blank">Terms of Service</a> and acknowledge our <a routerLink="/terms" target="_blank">Privacy Policy</a>.</p>
        </div>
      </div>
    </div>
    </div>
</ng-template>

<ng-template #showloader let-showloader>
  <div class="custom-dialog custom-dialog-centered show-loader" role="document">
    <div class="modal-content">
    	<div class="modal-body">
				<img class="main-loader-img" style="margin-top: 200px; width: 180px;" src="assets/img/loader.svg" alt="">
			  <h6 style="font-size: 16px;">Please wait</h6>
			  <p>Confirming your meeting time..</p>
			</div>
	</div>
</div>
</ng-template>


<ng-template #thankyou let-thankyou>
  <div class="custom-dialog custom-dialog-centered thanks-popup" role="document">
    <div class="modal-content">
      <div class="modal-body">
    		<h5>Thank you <br>Your meeting is confirmed. </h5>
    			<div class="conver-grid">
      			<div class="img-wrapper">
        			<img src="" >
        			<img src="assets/img/tick.png" class="tick">
      			</div>
      		<p>You are meeting with</p>
      		<h4>Sandeep Virk</h4>
    			</div>
    	<div class="invitation-wrapper">
      	<div class="">You will receive a meeting invitation shortly</div>
      		<table>
        	<tbody>
          	<tr>
            	<th>Event</th>
            	<td>Crafttor intro with Sandeep</td>
          	</tr>
          	<!-- <tr>
            	<th>Time</th>
            	<td>Friday, Oct 22nd, 08:30PM - 9:00PM IST</td>
          	</tr> -->
          	<tr>
            	<th>Guest</th>
            	<td>{{userName}}<span><a>{{userEmail}}</a></span></td>
          	</tr>
        	</tbody>
      	</table>
    	</div>
			<button id="singlebutton" name="singlebutton button" class="btn btn-primary" style="width: 100%;
    margin-top: 20px;" (click)="goToWorkspace()">Go to workspace</button>
  	</div>
	</div>
</div>
</ng-template>

<div
	style="width: 100%;
	background-color: rgba(0,0,0, .9);
  padding-top:200px;"
  class="modal"
  tabindex="-1"
  role="dialog"
  [ngStyle]="{'display':sendingProcessStyle}">
	<div class="modal-dialog-style modal-dialog-centered-style" role="document" style="height: 100px;
    width: 35%; margin: 0 auto; text-align: center;">
		<div class="modal-content" style="padding: 30px; background-color: rgb(255,255,255); border-radius: 10px;">
			<div class="modal-body">
				<img class="main-loader-img" style="width: 140px;" src="assets/img/loader.svg" alt="">
			  <h6 style="font-size: 16px;">Please wait</h6>
			  <p>Confirming your meeting time..</p>
			</div>
		</div>
	</div>
</div>

<div
	style="width: 100%;
	background-color: rgba(0,0,0, .9);
  padding-top:280px;"
  class="modal"
  tabindex="-1"
  role="dialog"
  [ngStyle]="{'display':upgradingSeatsProcessStyle}">
	<div class="modal-dialog-style modal-dialog-centered-style" role="document" style="width: 20%; margin: 0 auto; text-align: center;">
		<div class="modal-content" style="padding: 30px; background-color: rgb(255,255,255); border-radius: 10px;">
			<div class="modal-body">
				<img class="main-loader-img" style="width: 100px;" src="assets/img/loader.svg" alt="">
			</div>
		</div>
	</div>
</div>

<div
	style="width: 100%;
	background-color: rgba(0,0,0, .9);
  padding-top:200px;"
  class="modal"
  tabindex="-1"
  role="dialog"
  [ngStyle]="{'display':paymentProcessStyle}">
	<div class="modal-dialog-style modal-dialog-centered-style" role="document" style="height: 100px;
    width: 35%; margin: 0 auto; text-align: center;">
		<div class="modal-content" style="padding: 30px; background-color: rgb(255,255,255); border-radius: 10px;">
			<div class="modal-body">
				<img class="main-loader-img" style="width: 140px;" src="assets/img/loader.svg" alt="">
			  <h6>Please wait</h6>
			  <p>payment processing in progress..</p>
			</div>
		</div>
	</div>
</div>
